import React from 'react';
export default function CloseIcon() {
    return (React.createElement("svg", { className: "display-block", height: "6", viewBox: "0 0 6 6", width: "6" },
        React.createElement("path", { d: "M5.72,1.64A1,1,0,0,0,4.36.28L3,1.64,1.64,0.28A1,1,0,0,0,.28,\n        1.64L1.64,3,0.28,4.36A1,1,0,0,0,1.64,5.72L3,4.36,4.36,\n        5.72A1,1,0,0,0,5.72,4.36L4.36,3Z" })));
}
